/**
* Copyright by:

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

import { faBarcodeRead, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { LocationModel, RecordBaseModel, WorkflowItemType } from '../record-base.model';

export enum ScanState {
  SCANNED = 'SCANNED',
  MANUAL = 'MANUAL',
  NOT_SCANNED = 'NOT_SCANNED'
}

export class ScannerRecord extends RecordBaseModel {
  itemIcon: IconDefinition = faBarcodeRead;
  itemData?: ScannerRecordData;

  constructor(itemName: string, geolocation?: LocationModel, timestamp?: string) {
    super(itemName, WorkflowItemType.SCANNER, undefined, geolocation, timestamp);
  }

  fromJson(json: any): ScannerRecord | undefined {
    if (!json) return;

    let record = new ScannerRecord(
      json.itemName.value,
      LocationModel.fromJson(json.geolocation),
      json.timestamp?.value
    );
    let recordData = Object.create(ScannerRecordData.prototype);
    record.itemData = recordData.fromJson(json);

    return record;
  }
}

export class ScannerRecordData {
  hintTitle: string;
  hintText: string;
  barcodes: ScannerBarcodeRecordData[];

  constructor(title: string, text?: string, barcodes?: ScannerBarcodeRecordData[]) {
    this.hintTitle = title;
    this.hintText = text ?? '';
    this.barcodes = barcodes ?? [];
  }

  fromJson(json: any): ScannerRecordData {
    const hintTitle: string = json.hintTitle?.value ?? '';
    const hintText: string = json.hintText?.value ?? '';
    let barcodes: ScannerBarcodeRecordData[] = [];

    if (json.barcodes) {
      let scannerBarcodeRecordData = Object.create(ScannerBarcodeRecordData.prototype);
      for (const barcodeJson of json.barcodes.value) {
        barcodes.push(scannerBarcodeRecordData.fromJson(barcodeJson.value));
      }
    }

    return new ScannerRecordData(hintTitle, hintText, barcodes);
  }
}

export class ScannerBarcodeRecordData {
  barcode: string;
  barcodeType: string;
  scanTime: string;
  scanState: ScanState;

  constructor(barcode: string, barcodeType: string, scanTime: string, scanState: ScanState) {
    this.barcode = barcode;
    this.barcodeType = barcodeType;
    this.scanTime = scanTime;
    this.scanState = scanState;
  }

  fromJson(json: any): ScannerBarcodeRecordData {
    const barcode = json.barcode?.value ?? '';
    const barcodeType = json.barcodeType?.value ?? '';
    const scanTime = json.timestamp?.value ?? '';
    let scanState: ScanState;

    if (!json.barcodeType) {
      scanState = ScanState.NOT_SCANNED;
    } else if (json.barcodeType.value === 'manual') {
      scanState = ScanState.MANUAL;
    } else {
      scanState = ScanState.SCANNED;
    }

    return new ScannerBarcodeRecordData(barcode, barcodeType, scanTime, scanState);
  }
}
